var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinterest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "art",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 732.6 151.2",
    style: {
      enableBackground: "new 0 0 732.6 151.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2a1cb3;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M113.6,46.5h32.3V148h-32.3V46.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M152.7,46.5h31.1v13.9h0.6c7.5-10.9,17.2-16.8,31.3-16.8c22.2,0,35.3,15.9,35.3,38.5v66h-32.3V88.6 c0-10.7-5.4-18-15.9-18c-10.7,0-17.8,8.9-17.8,21.4V148h-32.3V46.5z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 129.8,
    cy: 19.4,
    r: 19.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M478.2,45.1c-0.9-0.1-2-0.1-3.2-0.1c-12.3,0-20.6,5.4-27.8,17.4h-0.6V46.5h-30.9V148h32.3v-45.6 c0-21.1,11.7-30.9,30.2-29.2V45.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M636.8,84c-12.9-2.4-24.4-3.4-24.4-10.5c0-6.3,6.1-9.3,14.1-9.3c8.9,0,15.1,2.8,16.3,11.9h29.7 c-1.6-20-17-32.5-45.8-32.5c-24,0-43.8,11.1-43.8,32.5c0,23.8,18.8,28.5,36.5,31.5c13.5,2.4,25.8,3.4,25.8,12.5 c0,6.5-6.1,10.1-15.9,10.1c-9.7,0-16.2-4.1-18.2-12.5h-30.8c2.3,20.9,20.6,33.5,49.2,33.5c26.6,0,46.2-11.5,46.2-33.7 C675.7,91.5,654.6,87,636.8,84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M530.1,127.8c-13.3,0-20.8-8.5-22.8-22.2h72.9c0.2-20.6-5.7-38.3-17.8-49.4c-8.7-7.9-20.2-12.7-34.7-12.7 c-30.9,0-52.1,23.2-52.1,53.5c0,30.7,20.6,53.9,54.1,53.9c12.9,0,23.2-3.4,31.7-9.3c8.9-6.1,14.9-14.9,17-24H547 C544.2,124,538.7,127.8,530.1,127.8z M528.4,66.6c10.5,0,18,7.7,19.2,19.8h-40C509.7,74.3,516.1,66.6,528.4,66.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M732.6,124.1c-1.5,0.1-3.5,0.1-5.4,0.1c-6.9,0-11.3-2-11.3-9.9V66.8h16.7V46.5h-16.7V14.4h-31.5v32.1h-9.9 v20.2h9.9v54.5c0,21.8,13.5,28,32.3,28c7.2,0,12.6-0.5,15.9-1.2V124.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M308.7,124.1c-1.3,0-2.8,0.1-4.2,0.1c-6.9,0-11.3-2-11.3-9.9V66.8h15.5V46.5h-15.5V14.4h-31.5v32.1h-10.5v20.2 h10.5v54.5c0,21.8,13.5,28,32.3,28c6.4,0,11.4-0.4,14.7-1V124.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M307.1,97.1c0-30.3,21.2-53.5,52.1-53.5c14.5,0,26,4.8,34.7,12.7c12.1,11.1,18,28.7,17.8,49.4h-72.9 c2,13.7,9.5,22.2,22.8,22.2c8.5,0,14.1-3.8,16.8-10.1H410c-2.2,9.1-8.1,17.8-17,24c-8.5,5.9-18.8,9.3-31.7,9.3 C327.7,151,307.1,127.8,307.1,97.1z M379.1,86.4c-1.2-12.1-8.7-19.8-19.2-19.8c-12.3,0-18.6,7.7-20.8,19.8H379.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,6.3h56.1c17.2,0,29.9,4.8,38.7,13.1C103.9,27.9,109,40,109,54.3c0,27.2-18.8,46.4-48,46.4H32.7V148H0V6.3z  M57.5,72.9c12.7,0,19.8-7.5,19.8-18.8c0-11.3-7.3-18.2-19.8-18.2H32.7v37.1H57.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/pinterest.5239636a2e1b61807b41bfb00c74e5bd.svg";
export { ForwardRef as ReactComponent };